import { boot } from "quasar/wrappers";
// required
import "@fortawesome/fontawesome-pro/css/fontawesome.css";
import "@fortawesome/fontawesome-pro/css/light.css";

// optional
import "@fortawesome/fontawesome-pro/css/thin.css";
import "@fortawesome/fontawesome-pro/css/duotone.css";
import "@fortawesome/fontawesome-pro/css/brands.css";
import "@fortawesome/fontawesome-pro/css/solid.css";
import "@fortawesome/fontawesome-pro/css/regular.css";

export default boot(({ app }) => {
  // Override default icons
  // First, find the icon used in Quasar Fontawesome v6 Pro icon-set source:
  // https://github.com/quasarframework/quasar/blob/dev/ui/icon-set/fontawesome-v6-pro.js
  // Then override it. For example "chip.remove":
  // app.config.globalProperties.$q.iconSet.chip.remove = "fas fa-times-circle";
  app.config.globalProperties.$q.iconSet.table.arrowUp = "fa-light fa-caret-up";
});
